import React from 'react';
import { View, Text } from 'react-native';
import styles from '../../style/scanpack';
import OrderItem from '../../commons/orderItem';
import OrderItemImage from '../../commons/orderItemImage';

const NotFulfilledItems = ({ notFullFilledItems, redirectToItemDetail, shuffleTheItem }) => {
  if (!notFullFilledItems || notFullFilledItems.length === 0) {
    return null;
  }

  const totalCount = notFullFilledItems.reduce((count, item) => {
    return count + (item.skipped_qty || 0);
  }, 0);

  return (
    <View style={styles.notFulfilledSection}>
      <Text style={styles.notFulfilledHeaderTitle}>
        {totalCount} Not Fulfilled Items
      </Text>
      {notFullFilledItems.map((item, index) => (
        <View 
          key={`not-fulfilled-${item.product_id}-${index}`} 
          style={styles.scanPackSingleItemContainer}
        >
          <OrderItem
            item={item}
            redirectToItemDetail={redirectToItemDetail}
            testID={'redirectToItem'}
          />
          <OrderItemImage
            item={item}
            shuffleTheItem={shuffleTheItem}
            testID={'shuffleItem'}
            listType={'notFulfilled'}
            isNotFullFilled={true}
          />
        </View>
      ))}
    </View>
  );
};

export default NotFulfilledItems;

